import { useEffect, useState } from 'react'

import { Brand } from './Brand'
import { Cta } from './Cta'

type HeaderProps = {
  audience?: 'firms' | 'professionals'
}

export function Header({ audience = 'firms' }: HeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false)
  const [sticky, setSticky] = useState(false)

  useEffect(() => {
    const updateHeader = () => setSticky(window.scrollY > 12)
    const closeOnDesktop = () => {
      if (window.innerWidth > 820) setMenuOpen(false)
    }

    updateHeader()
    window.addEventListener('scroll', updateHeader, { passive: true })
    window.addEventListener('resize', closeOnDesktop, { passive: true })

    return () => {
      window.removeEventListener('scroll', updateHeader)
      window.removeEventListener('resize', closeOnDesktop)
    }
  }, [])

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen)
    return () => document.body.classList.remove('menu-open')
  }, [menuOpen])

  const closeMenu = () => setMenuOpen(false)
  const professionalPage = audience === 'professionals'

  return (
    <header className={`site-header${sticky ? ' is-sticky' : ''}`}>
      <nav className="nav-wrap" aria-label="Primary navigation">
        <Brand href="/#top" />
        <button
          className={`menu-button${menuOpen ? ' is-open' : ''}`}
          type="button"
          aria-expanded={menuOpen}
          aria-controls="nav-links"
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          onClick={() => setMenuOpen((current) => !current)}
        >
          <span />
          <span />
          <span />
        </button>
        <div
          className={`nav-links${menuOpen ? ' is-open' : ''}`}
          id="nav-links"
        >
          {professionalPage ? (
            <>
              <a href="#opportunity" onClick={closeMenu}>Opportunity model</a>
              <a href="#professional-process" onClick={closeMenu}>How it works</a>
              <a href="#professional-faqs" onClick={closeMenu}>FAQs</a>
              <a className="nav-audience-link is-current" href="/for-professionals" onClick={closeMenu} aria-current="page">
                For professionals
              </a>
              <a className="button button--small" href="#professional-enquiry" onClick={closeMenu}>
                Share your interest
              </a>
            </>
          ) : (
            <>
              <a href="#why-ark" onClick={closeMenu}>Why Ark Solutions</a>
              <a href="#how-it-works" onClick={closeMenu}>How it works</a>
              <a href="#why-south-africa" onClick={closeMenu}>Why South Africa</a>
              <a href="#faqs" onClick={closeMenu}>FAQs</a>
              <a className="nav-audience-link" href="/for-professionals" onClick={closeMenu}>
                For professionals
              </a>
              <Cta className="button--small" onClick={closeMenu}>
                Explore your talent requirements
              </Cta>
            </>
          )}
        </div>
      </nav>
    </header>
  )
}
